/**
 * @module domains/application/sagas/workers.js
 */
import { all } from 'redux-saga/effects';

import ApplicationConstants from '../../constants';
import * as D from '../../deps';

import {
  addPageVisibilityHandler,
  detectBrowserAutoplayBlocked,
  goOffline,
  goOnline,
  handleStartupQueryParameters,
  onExternalRedirect,
  onFirstAudioPlay,
  openBrowserAutoplayBlockModal,
  openLinkedPlaylistUnlockedModal,
  pollNetwork,
  setReferrerCookie,
  watchActions,
} from './Application';
import {
  closeAdBlockerModal,
  detectAdBlockerWatcher,
  initiateHammerAdBlockHandler,
  openAdBlockerModal,
} from './BlockerDetection';
import { idleMonitor } from './IdleMonitor';
import { managePersistor, onLogoutAttempt } from './Persistor';

const log = D.Logger.child({
  component: 'domains/application/sagas/workers/Application',
});
const spawn = D.taskManagerSpawnFactory(ApplicationConstants.DOMAIN_NAME);

/**
 * Bootstrap application
 */
export function* initializeApplication() {
  log.info('initializeApplication(): initializing application');

  yield all([
    spawn(handleStartupQueryParameters),
    spawn(setReferrerCookie),
    spawn(watchActions),
    spawn(managePersistor),
    spawn(pollNetwork),
    spawn(addPageVisibilityHandler),
    spawn(idleMonitor),
  ]);
}

export {
  closeAdBlockerModal,
  detectAdBlockerWatcher,
  detectBrowserAutoplayBlocked,
  goOffline,
  goOnline,
  initiateHammerAdBlockHandler,
  onExternalRedirect,
  onFirstAudioPlay,
  onLogoutAttempt,
  openAdBlockerModal,
  openBrowserAutoplayBlockModal,
  openLinkedPlaylistUnlockedModal,
};
